import React, { useEffect, useState } from "react";
import SlickSlider from "../SlickSlider/SlickSlider";
import FamousResidentsItem from "./FamousResidentsItem";
import FamousResidentsStats from "../FamousResidentsStats/FamousResidentsStats";
import { useLanguage } from "../../context/LanguageContext";

const FamousResidents = () => {
  const { t } = useLanguage();

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const resident_items = [
    {
      name: t("famousResidents.items.0.name"),
      profession: t("famousResidents.items.0.profession"),
      status: t("famousResidents.items.0.status"),
      quote: t("famousResidents.items.0.quote"),
      country: t("famousResidents.items.0.country"),
      category: t("famousResidents.items.0.category"),
      categoryType: "tech"
    },
    {
      name: t("famousResidents.items.1.name"),
      profession: t("famousResidents.items.1.profession"),
      status: t("famousResidents.items.1.status"),
      quote: t("famousResidents.items.1.quote"),
      country: t("famousResidents.items.1.country"),
      category: t("famousResidents.items.1.category"),
      categoryType: "entertainment"
    },
    {
      name: t("famousResidents.items.2.name"),
      profession: t("famousResidents.items.2.profession"),
      status: t("famousResidents.items.2.status"),
      quote: t("famousResidents.items.2.quote"),
      country: t("famousResidents.items.2.country"),
      category: t("famousResidents.items.2.category"),
      categoryType: "bollywood"
    },
    {
      name: t("famousResidents.items.3.name"),
      profession: t("famousResidents.items.3.profession"),
      status: t("famousResidents.items.3.status"),
      quote: t("famousResidents.items.3.quote"),
      country: t("famousResidents.items.3.country"),
      category: t("famousResidents.items.3.category"),
      categoryType: "sport"
    },
    {
      name: t("famousResidents.items.4.name"),
      profession: t("famousResidents.items.4.profession"),
      status: t("famousResidents.items.4.status"),
      quote: t("famousResidents.items.4.quote"),
      country: t("famousResidents.items.4.country"),
      category: t("famousResidents.items.4.category"),
      categoryType: "sport"
    },
    {
      name: t("famousResidents.items.5.name"),
      profession: t("famousResidents.items.5.profession"),
      status: t("famousResidents.items.5.status"),
      quote: t("famousResidents.items.5.quote"),
      country: t("famousResidents.items.5.country"),
      category: t("famousResidents.items.5.category"),
      categoryType: "hollywood"
    },
    {
      name: t("famousResidents.items.6.name"),
      profession: t("famousResidents.items.6.profession"),
      status: t("famousResidents.items.6.status"),
      quote: t("famousResidents.items.6.quote"),
      country: t("famousResidents.items.6.country"),
      category: t("famousResidents.items.6.category"),
      categoryType: "sport"
    },
    {
      name: t("famousResidents.items.7.name"),
      profession: t("famousResidents.items.7.profession"),
      status: t("famousResidents.items.7.status"),
      quote: t("famousResidents.items.7.quote"),
      country: t("famousResidents.items.7.country"),
      category: t("famousResidents.items.7.category"),
      categoryType: "fashion"
    },
    {
      name: t("famousResidents.items.8.name"),
      profession: t("famousResidents.items.8.profession"),
      status: t("famousResidents.items.8.status"),
      quote: t("famousResidents.items.8.quote"),
      country: t("famousResidents.items.8.country"),
      category: t("famousResidents.items.8.category"),
      categoryType: "gastronomy"
    },
    {
      name: t("famousResidents.items.9.name"),
      profession: t("famousResidents.items.9.profession"),
      status: t("famousResidents.items.9.status"),
      quote: t("famousResidents.items.9.quote"),
      country: t("famousResidents.items.9.country"),
      category: t("famousResidents.items.9.category"),
      categoryType: "crypto"
    }
  ];

  const initalState = 0;
  const [count, setCount] = useState(initalState);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((old) => (old == 10 ? 0 : old + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const toMultiply = 100 / resident_items.length;

  return (
    <section className="famous-residents-area pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="section-title text-center mb-50">
              <h2 className="title text-info">
                {t("famousResidents.title")}
              </h2>
              <p className="description text-light mt-4" style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                {t("famousResidents.description")}
              </p>
            </div>
          </div>
        </div>

        <div className="row famous-residents-active">
          <SlickSlider settings={slickSettings}>
            {resident_items.map((item, index) => (
              <div key={index} className="col-lg-4">
                <FamousResidentsItem item={item} />
              </div>
            ))}
          </SlickSlider>
        </div>

        <div 
          className="slide-progressbar"
          style={{
            display: "block",
            width: "100%",
            height: "3px",
            borderRadius: "0",
            background: "rgba(255, 255, 255, 0.1)",
            marginTop: "30px"
          }}
        >
          <div
            style={{
              height: "2px",
              backgroundImage: "linear-gradient(to right, #00c4f4, #00c4f4)",
              backgroundRepeat: "no-repeat",
              backgroundSize: `${count * toMultiply}% 100%`,
              transition: "background-size 0.3s ease"
            }}
            className="slide-filler"
          />
        </div>
      </div>
      
      {/* Famous Residents Stats */}
      <FamousResidentsStats />
    </section>
  );
};

export default FamousResidents;
